import { render, staticRenderFns } from "./ProductSlider.vue?vue&type=template&id=335efede&scoped=true"
import script from "./ProductSlider.vue?vue&type=script&lang=js"
export * from "./ProductSlider.vue?vue&type=script&lang=js"
import style0 from "./ProductSlider.vue?vue&type=style&index=0&id=335efede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335efede",
  null
  
)

export default component.exports